import { Suspense, type ReactNode } from 'react'
import { useHydrated } from '#app/hooks/use-hydrated.tsx'

type Props = {
	children(): ReactNode
	fallback?: ReactNode
}

export function ClientOnly({ children, fallback = null }: Props) {
	const isHydrated = useHydrated()

	if (!isHydrated) {
		return <>{fallback}</>
	}

	return <Suspense fallback={fallback}>{children()}</Suspense>
}
